import styled from 'styled-components';

import { Popup } from 'components/uikit/Popup/Popup';

export const Container = styled(Popup)`
  width: 432px;
  min-height: max-content;
  padding: 24px;
`;
